import catalogueTemplateApi from '../templates/sagas/api';
import catalogueApi from './api';
import catalogueToasts from './toasts';

export default [
  catalogueApi(),
  catalogueTemplateApi(),
  catalogueToasts(),
];
